export type Product = {
  heading: string;
  description: string[];
  specialOffer?: string;
  image: string;
  fullImage: string;
  priceConstructor: {
    prices: string[];
    joiner: string;
    endOfLine?: string;
    startOfLine?: string;
  }
}

export const products: ReadonlyArray<Product> = [
  {
    heading: 'Icons',
    description: ['A custom digital illustration with 600x600 pixels resolution.'],
    image: '/image/prices/icon.jpg',
    fullImage: '/image/prices/icon.jpg',
    specialOffer: 'if you would like it cell-shaded',
    priceConstructor: {
      prices: ['$80', '$70'],
      joiner: ' or ',
      endOfLine: ' ea.',
    }
  },
  {
    heading: 'Crop Shot (Basic Coloring)',
    description: ['Custom artwork of your character with almost no shading. You will recieve a digital illustration with 1500 pixels resolution on a wider side.'],
    image: '/image/prices/basiccrop.jpg',
    fullImage: '/image/prices/basiccrop.jpg',
    specialOffer: 'if you order more than one',
    priceConstructor: {
      prices: ['$100', '$95'],
      joiner: ' or ',
      endOfLine: ' ea.',
    }
  },
  {
    heading: 'Crop Shot (Simplified Shading)',
    description: ['Custom artwork of your character with simplified shading. You will recieve a digital illustration with 1500 pixels resolution on a wider side.'],
    image: '/image/prices/simplifiedcrop.jpg',
    fullImage: '/image/prices/simplifiedcrop.jpg',
    specialOffer: 'if you order more than one',
    priceConstructor: {
      prices: ['$150', '$145'],
      joiner: ' or ',
      endOfLine: ' ea.',
    }
  },
  {
    heading: 'Illustration (Simplified Shading)',
    description: ['Custom artwork of your character with simplified shading. You will recieve a digital illustration with 2500 pixels resolution on a wider side.'],
    image: '/image/prices/simplified.jpg',
    fullImage: '/image/prices/simplified.jpg',
    specialOffer: 'if you choose "Artistic Freedom" option',
    priceConstructor: {
      prices: ['$250', '$200'],
      joiner: ' or ',
      endOfLine: ' per character',
    }
  },
  {
    heading: 'Illustration (Soft Shading Shading)s',
    description: ['Custom artwork of your character with soft shading. You will recieve a digital illustration with 2500 pixels resolution on a wider side.'],
    image: '/image/prices/soft.jpg',
    fullImage: '/image/prices/soft.jpg',
    specialOffer: 'if you choose "Artistic Freedom" option',
    priceConstructor: {
      prices: ['$350', '$300'],
      joiner: ' or ',
      endOfLine: ' per character',
    }
  },
  {
    heading: 'Commissions feat. Fleki',
    description: ['You can use my character for your commissions. $1000 for simplified shading and 1500 for soft shading. Prices are for 2 characters with artistic freedom option. Exact ideas are +$500.'],
    image: '/image/prices/fleki.jpg',
    fullImage: '/image/prices/fleki.jpg',
    priceConstructor: {
      prices: ['$1000', '$2500'],
      joiner: ' - ',
      endOfLine: ' ',
      startOfLine: 'Price range: ',
    }
  },
];